export default __webpack_public_path__ + "static/media/bal-2-promo.62001641.webp";